import React from "react";
import OrderForm from "./OrderForm";
import Xhr from "../../../../helpers/Xhr";

class ByInvestbank extends OrderForm {
	static defaultProps = {
		minAmount : 10
	};

	state = {
		amount : this.props.minAmount,
		toPay  : this.props.minAmount * 0.96,
		nalog  : this.props.minAmount * 0.04,
		phone  : ''
	};

	onSubmit() {
		const data = {
			amount : this.state.amount,
			phone  : this.state.phone
		};

		if ( !this.hasErrors ) {
			Xhr.cashOutInvestbank(data).then((resp) => {
				this.setState({
					messages : resp.messages
				});
			});
		}
	}

	render() {
		return (
			<div className="description__order">
				{/*Сумма заказа*/}
				{this.getAmountRow()}

				{/*Сумма к выплате*/}
				{this.getToPayRow()}

				{/*Налог*/}
				{this.getNalogRow()}

				{/*Номер телефона*/}
				{this.getPhoneRow()}

				{this.getOrderButton()}

				{this.state.messages !== '' &&
				<div className="description__order-item">
					<div></div>
					<div className="errors">{this.state.messages}</div>
					<div></div>
				</div>}
			</div>
		);
	}
}

export default ByInvestbank;


// WEBPACK FOOTER //
// ./src/app/pages/User/Takemoney/Form/ByInvestbank.js